import MobileEditProfile from 'modules/profile/ProfileMobileView/Edit/MobileEditProfile.js'

export default MobileEditProfile
